import React from 'react'
import createAuth0Client from '@auth0/auth0-spa-js'
import { auth0ClientOption } from '../../../lib/Auth0'
import { makeID } from '../../../lib'
import { useEffect } from 'react'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { notifyLogin } from '../actions'

export const Auth0Context = React.createContext()

export const Auth0Provider = (props) => {
  const { children, language } = props

  const [auth0, setAuth0] = useState(undefined)
  const [user, setUser] = useState(null)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [authStateChangeListener, setAuthStateChangeListener] = useState([])
  const [isInitialized, setIsInitialized] = useState(false)

  const history = useHistory()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!isInitialized) {
      var auth0Client
      const { createdAuth0Client, changedAuthState } = props
      createAuth0Client(auth0ClientOption, language)
      .then(result => {
        auth0Client = result
        createdAuth0Client(auth0Client)
        setAuth0(auth0Client)
        return auth0Client.isAuthenticated()
      })
      .then(isAuthenticated => {
        setIsAuthenticated(isAuthenticated)
        return auth0Client.getUser()
      })
      .then(user => {
        setUser(user)
        setIsInitialized(true)
        changedAuthState(user, language, history)
        authStateChangeListener.forEach(listener => {
          listener.callback(user)
        })
      })
    }
  }, [isInitialized])

  const onAuthStateChanged = (callback) => {
    const id = makeID()
    setAuthStateChangeListener(authStateChangeListener.concat({ callback, id }))
    return id
  }

  const unregisterAuthStateChanged = (id) => {
    setAuthStateChangeListener(authStateChangeListener.filter(lister => lister !== id))
  }

  const login = () => {
    return auth0.loginWithPopup({})
    .then(response => {
      return dispatch(notifyLogin())
    })
    .then(response => {
      window.location.reload()
    })
  }

  const logout = () => {
    const { changedAuthState } = props
    auth0.logout()
    changedAuthState(null, language, history)
  }

  return (
    <Auth0Context.Provider
      value={{
        auth0,
        user,
        isAuthenticated,
        authStateChangeListener,
        isInitialized,
        login,
        logout,
        onAuthStateChanged,
        unregisterAuthStateChanged,
      }}
    >
      {children}
    </Auth0Context.Provider>
  )
}




// WEBPACK FOOTER //
// ./src/Parts/Auth0/components/Auth0Provider.js